import { createSlice } from "@reduxjs/toolkit";
const initialState = {};

const SliceGRNConfiguration = createSlice({
  name: "GRNConfiguration",
  initialState: { value: initialState },

  reducers: {
    GrnConfiguration_Set: (state, action) => {
      state.value = action.payload;
    },

    GrnConfiguration_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { GrnConfiguration_Set, GrnConfiguration_Init } =
  SliceGRNConfiguration.actions;
export default SliceGRNConfiguration.reducer;
